var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-cabinet-referral-info-list-table"},[_c('ui-table',_vm._b({attrs:{"theme":"secondary"}},'ui-table',_vm.tableData,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }